import React from 'react';
import { Icon } from '../core/Icon.jsx';

/** Label + control + hint/error wrapper. */
export function Field({ label, hint, error, required = false, htmlFor, className = '', children }) {
  return (
    <div className={`bjl-field ${className}`}>
      {label ? (
        <label className="bjl-field__label" htmlFor={htmlFor}>
          {label}
          {required ? <em>*</em> : null}
        </label>
      ) : null}
      {children}
      {error ? (
        <span className="bjl-field__error"><Icon name="error" size={13} fill />{error}</span>
      ) : hint ? (
        <span className="bjl-field__hint">{hint}</span>
      ) : null}
    </div>
  );
}
